// Definición de defaults

export const defaultClaseExhorto: ClaseExhortoProps = {
    idClaseExhorto: 0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface ClaseExhortoProps {
    idClaseExhorto:        number;
    descripcion:             string;
    activo:                  boolean;
}